(function () {
  function initReveal() {
    var els = document.querySelectorAll('.pw-reveal:not(.pw-visible)');
    if (!els.length) return;
    if (!('IntersectionObserver' in window) || window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      els.forEach(function (el) { el.classList.add('pw-visible'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('pw-visible'); io.unobserve(e.target); }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -40px 0px' });
    els.forEach(function (el) { io.observe(el); });
  }

  function initComparador() {
    document.querySelectorAll('.pw-ba').forEach(function (ba) {
      if (ba.dataset.ready) return;
      ba.dataset.ready = '1';
      var range = ba.querySelector('.pw-ba__range');
      if (!range) return;
      function set() { ba.style.setProperty('--pos', range.value + '%'); }
      range.addEventListener('input', set);
      set();
    });
  }

  function init() { initReveal(); initComparador(); }
  document.addEventListener('DOMContentLoaded', init);
  document.addEventListener('shopify:section:load', init);
})();
